// The Quotes tab of a public figure's page (15 October 2026).
export default {
  filtres: {
    aria: 'Filter quotes',
    qui: 'Who speaks',
    toutes: 'All',
    ou: 'Where',
    partout: 'Everywhere',
    sujet: 'Topic',
    tous: 'All',
    periode: 'Period',
    j7: '7 days',
    j30: '30 days',
    tout: 'Since following',
  },
  compte: '{n} quote {periode}, with its source, date and time | {n} quotes {periode}, each with its source, date and time',
  periodeCompte: { j7: 'over 7 days', j30: 'over 30 days', tout: 'since following began' },
  jour: { aujourdhui: 'Today, {jour}', hier: 'Yesterday, {jour}' },
  voirPlus: 'Show more',
  chargement: 'Loading quotes…',
  vide: 'No quotes over this period',
  exporter: 'Export',
  exportEnCours: 'Exporting…',
  erreurExport: 'The export failed.',
  csv: {
    date: 'Date',
    heure: 'Time (Paris)',
    genre: 'Who speaks',
    plateforme: 'Platform',
    auteur: 'Author',
    media: 'Outlet',
    sujet: 'Topic',
    position: 'Position',
    sens: 'Tone',
    extrait: 'Excerpt',
    source: 'Source address',
    releve: 'Captured on',
  },
}
